export default {
  // Heading:
  title: {
    ar: 'يرجى إدخال بياناتك للانضمام إلى السحب!سيتم اختيار الفائزين عشوائياً. ترقبوا المزيد',
    en: 'Please enter your details to join the raffle draw. Winners will be selected at random. Stay tuned!'
  },

  description: {
    ar: '*جميع الحقول إلزامية',
    en: 'All fields are mandatory*'
  },

  // First Section:
  information: {
    ar: '',
    en: 'Personal information'
  },

  firstName: {
    ar: '*الاسم الأول',
    en: 'First name*'
  },

  lastName: {
    ar: '*اسم العائلة',
    en: 'Last name*'
  },

  emailAddress: {
    ar: '*عنوان البريد الإلكتروني',
    en: 'Email Address*'
  },

  phoneNumber: {
    ar: '*رقم الهاتف المحمول',
    en: 'Mobile Number*'
  },

  nationality: {
    ar: '*الجنسية',
    en: 'Nationality*'
  },

  idNumber: {
    ar: '*رقم الهوية الإماراتية',
    en: 'Emirates ID Number*'
  },

  /* dateBirth: {
    en: 'Date Birth'
  },

  size: {
    en: 'Size'
  },

  textArea: {
    en: 'Message'
  },

  // Second Section:
  address: {
    en: 'Address'
  },

  postalCode: {
    en: 'Postal Code'
  },

  houseNumber: {
    en: 'House Number'
  },

  suffix: {
    en: 'Addition'
  },

  streetName: {
    en: 'Street'
  },

  venue: {
    en: 'Place'
  }, */

  infoLabel: {
    ar: '*المعلومات الشخصية التي قدمتها صحيحة',
    en: 'The personal information I\'ve provided is correct*'
  },

  // Terms:
  termsLabel: {
    ar: '',
    en: 'Yes, I accept the'
  },

  link: {
    ar: 'أوافق على الشروط والأحكام',
    en: 'Terms & Conditions'
  },

  termsHref: {
    ar: 'https://storage.googleapis.com/media-mcd-uae-fanshop-prod/terms/Brand_Trust_Game.pdf?openOutsideMcd=true',
    en: 'https://storage.googleapis.com/media-mcd-uae-fanshop-prod/terms/Brand_Trust_Game.pdf?openOutsideMcd=true'
  },

  asteriskAR: {
    ar: '*',
    en: '',
  },

  asteriskEN: {
    ar: '',
    en: '*',
  },

  // Errors:
  firstNameError: {
    ar: 'يرجى إدخال الاسم الأول بشكل صحيح',
    en: 'Please enter a valid first name'
  },

  lastNameError: {
    ar: 'يرجى إدخال اسم العائلة بشكل صحيح',
    en: 'Please enter a valid last name'
  },

  emailAddressError: {
    ar: 'يرجى إدخال عنوان بريد إلكتروني صحيح',
    en: 'Please enter a valid email address'
  },

  phoneNumberError: {
    ar: 'يرجى إدخال رقم هاتف صحيح',
    en: 'Please enter a valid phone number'
  },

  nationalityError: {
    ar: 'يرجى إدخال جنسيتك',
    en: 'Please enter your nationality'
  },

  idNumberError: {
    ar: 'يرجى إدخال رقم هوية صحيح',
    en: 'Please enter a valid ID number'
  },

  /* dateBirthError: {
    en: 'Please enter a valid birth date'
  },

  sizeError: {
    en: 'Please enter a valid size'
  },

  textAreaError: {
    en: 'Please enter a message'
  },

  addressError: {
    en: 'Please enter a valid address'
  },

  postalCodeError: {
    en: 'Please enter a valid zip code'
  },

  houseNumberError: {
    en: 'Please enter a valid house number'
  },

  suffixError: {
    en: 'Please enter a valid addition'
  },

  streetNameError: {
    en: 'Please enter a valid street name'
  },

  venueError: {
    en: 'Required field'
  }, */

  infoError: {
    ar: 'إلزامي',
    en: 'Mandatory'
  },

  termsError: {
    ar: 'إلزامي',
    en: 'Mandatory'
  },

  // Submit:
  submit: {
    ar: 'إرسال',
    en: 'Send'
  }
};
